import { Icon, StatusBadgeStyled, Text } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CurrencyName } from '@webapp/models/enums'
import { BillItemPopoverLayout } from './BillItemPopoverLayout'
import messages from './messages'

interface BillItemTaxExceedsSubtotalPopoverContentProps {
  calculatedTaxAmount: number
  currencyName: CurrencyName
}

export const BillItemTaxExceedsSubtotalPopoverContent = ({
  calculatedTaxAmount,
  currencyName,
}: BillItemTaxExceedsSubtotalPopoverContentProps) => {
  const intl = useProcurifyIntl()

  return (
    <BillItemPopoverLayout
      title={intl.formatMessage(messages.taxAmountEditedTitle)}
      badge={
        <StatusBadgeStyled type='warning' size='medium'>
          <Icon icon='attention' size={12} />
          <span style={{ marginLeft: '4px' }}>
            {intl.formatMessage(messages.taxExceedsSubtotalBadge)}
          </span>
        </StatusBadgeStyled>
      }
      description={
        <Text>
          {intl.formatMessage(messages.taxExceedsSubtotalDescription)}
        </Text>
      }
      bodyRows={[
        {
          id: 'system-calculated-tax',
          label: intl.formatMessage(messages.systemCalculatedTaxLabel),
          valueComponent: (
            <Price
              price={calculatedTaxAmount}
              currency={currencyName}
              fontWeight='normal'
            />
          ),
        },
      ]}
    />
  )
}

BillItemTaxExceedsSubtotalPopoverContent.displayName =
  'BillItemTaxExceedsSubtotalPopoverContent'
